(() => {
  if (customElements.get('helior-native-ring-sizes')) return;
  const systems = ['UK', 'EU', 'US'];
  const preferenceKey = 'helior:native-ring-system:v1';

  class HeliorNativeRingSizes extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => {
        if (!this.isConnected || this.initialized) return;
        this.initialized = true;
        this.select = this.querySelector('[data-native-select]');
        this.sizeOptions = [...this.querySelectorAll('[data-native-size]')];
        this.placeholder = this.querySelector('[data-native-placeholder]');
        this.root = this.closest('product-info') || this.parentElement;
        const selected = this.querySelector('[data-native-size]:checked');
        // Keep user intent outside variant-selects, which Shopify replaces after each request.
        let state = this.root.heliorNativeRingState;
        if (!state || state.country !== this.dataset.country) {
          let system = this.dataset.defaultSystem;
          try {
            const saved = JSON.parse(sessionStorage.getItem(preferenceKey));
            if (saved?.country === this.dataset.country && systems.includes(saved.system)) system = saved.system;
          } catch {}
          state = { country: this.dataset.country, system: selected?.dataset.system || system, value: selected?.value || '', pending: false };
          this.root.heliorNativeRingState = state;
        }
        this.state = state;
        if (selected?.value === state.value) state.pending = false;
        this.onClick = (event) => {
          const button = event.target.closest('[data-native-system]');
          if (button && this.contains(button)) this.switchSystem(button.dataset.nativeSystem);
          if (event.target.closest('[data-native-guide]')) {
            event.preventDefault();
            const guide = this.querySelector('details');
            guide.open = !guide.open;
            if (guide.open) guide.querySelector('summary').focus();
          }
        };
        this.onChange = (event) => {
          if (!event.target.matches('[data-native-select]')) return;
          this.state.value = event.target.value;
          this.state.pending = true;
          this.update();
          // Let the native VariantSelects handler fetch the actual selected variant.
        };
        this.addEventListener('click', this.onClick);
        this.addEventListener('change', this.onChange);
        this.querySelector('.helior-ring-sizes__systems').hidden = false;
        this.update();
      });
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('change', this.onChange);
      this.initialized = false;
    }

    switchSystem(system) {
      if (!systems.includes(system) || system === this.state.system) return;
      this.root.abortController?.abort();
      this.state.system = system;
      this.state.value = '';
      this.state.pending = false;
      try { sessionStorage.setItem(preferenceKey, JSON.stringify({ country: this.dataset.country, system })); } catch {}
      // A system change does not silently order a converted or default size.
      this.update();
    }

    get selected() {
      return this.querySelector('[data-native-size]:checked');
    }

    requestFailed() {
      this.state.value = '';
      this.state.pending = false;
      this.update();
    }

    canSubmit() {
      const selected = this.selected;
      const id = document.getElementById(this.dataset.formId)?.querySelector('[name="id"]')?.value;
      return !!(this.state && !this.state.pending && selected && selected.value === this.state.value &&
        selected.dataset.system === this.state.system && selected.dataset.available === 'true' &&
        selected.dataset.variantId && id === selected.dataset.variantId);
    }

    update() {
      const sizeRank = (option) => {
        const label = option.dataset.nativeLabel;
        return option.dataset.system === 'UK'
          ? label.charCodeAt(0) * 2 + (label.includes('½') ? 1 : 0)
          : Number(label);
      };
      const visibleOptions = this.sizeOptions
        .filter((option) => option.dataset.system === this.state.system)
        .sort((a, b) => sizeRank(a) - sizeRank(b));
      this.placeholder.textContent = this.dataset.placeholderLabel;
      this.select.replaceChildren(this.placeholder, ...visibleOptions);
      this.select.setAttribute('aria-label', `Ring size (${this.state.system})`);
      visibleOptions.forEach((option) => {
        if (option.dataset.available === 'true') option.textContent = option.dataset.nativeLabel;
      });
      this.select.value = this.state.value;
      if (!this.select.value) this.select.value = '';
      const selectedValue = this.select.value;
      [...this.select.options].forEach((option) => {
        if (option.value === selectedValue) option.setAttribute('selected', 'selected');
        else option.removeAttribute('selected');
      });
      this.select.value = selectedValue;
      this.querySelectorAll('[data-native-system]').forEach((button) => {
        button.setAttribute('aria-pressed', String(button.dataset.nativeSystem === this.state.system));
      });
      this.querySelector('[data-ring-system-heading]').textContent = `(${this.state.system})`;
      const property = this.querySelector('[data-ring-property]');
      const selected = this.selected;
      property.value = selected?.value || '';
      property.disabled = !selected || this.state.pending;
      const status = this.querySelector('[data-native-status]');
      status.hidden = !selected && !this.state.pending;
      status.textContent = this.state.pending ? this.dataset.loadingLabel : selected
        ? `${this.dataset.selectedLabel} ${selected.value}` : `${this.dataset.chooseLabel} (${this.state.system})`;
      if (!selected || this.state.pending) {
        const form = document.getElementById(this.dataset.formId);
        const id = form?.querySelector('[name="id"]');
        if (id) id.value = '';
        this.root.querySelector('product-form')?.toggleSubmitButton(true,
          this.state.pending ? this.dataset.loadingLabel : this.dataset.chooseLabel);
      }
    }
  }
  customElements.define('helior-native-ring-sizes', HeliorNativeRingSizes);
})();
